// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__z8aV9","message":"styles_message__emMm3"};